<template>	
	<main class="h-100 w-100 d-flex flex-column justify-content-center align-items-center"> 
		<p class="text-center font-weight-bold" style="color: #325591;">No estás autorizado a ver este contenido. ¡Cómpralo ahora y podrás empezar!</p>
	</main> 
</template>

<script>
import AuthButton from '@/components/AuthButton.vue'
import { useStore } from 'vuex';
import { onMounted } from '@vue/runtime-core';
export default {
	name: "NotPaid",
	components: { AuthButton},
	setup(){
		const store = useStore();
		
		onMounted(()=>{
			if(!store.getters.requesting.value) document.getElementById('comprar-button').click()
		})

	}
};
</script>
